module.exports = __webpack_public_path__ + "static/hero-background-43b90d000cc431d68dc3d96d9b63b3b0.png";